import React from 'react'

const ButtonSecondary = ({children, className, thin, ...props}) => {
  return (
    <button className={`bg-secondary rounded uppercase text-center ${thin ? 'p-2' : 'p-4'} w-full text-white font-bold text-sm ${className}`} {...props}>
      {children}
    </button>
  )
}

export { ButtonSecondary }
